export default __webpack_public_path__ + "assets/913723deb0c67efa55fc28b34f837d4c.svg";